import React from 'react'
import { Box, Button, Container, Grid, Typography, } from '@mui/material';
import { Link } from 'react-router-dom';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Profilealltab from '../Profiletabpages/Profilealltab';
import Propic from "../../../images/Profile.png"; 
import { useState } from 'react';
import { useEffect } from 'react';
import {ABI, API_URL, APP_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid } from '../../../Config';
import axios from 'axios';
import { useWeb3React } from '@web3-react/core';
import swal from "sweetalert";
import tokenabi from "../../../Config/tokenabi.json";
import { Modal, Text, Input } from "@nextui-org/react";
import styled from 'styled-components';
import Loading from "../../../Components/loader/loader";

const Myitems = () => {
  const [visible, setVisible] = React.useState(false);
  const handler = () => setVisible(true);

  const closeHandler = () => {
    setVisible(false);
  };

  const { active ,account,chainId ,library} = useWeb3React();
  const [user,setuserdata]= useState([]);
  const [Buydate,setbuydate]= useState([]);
  const [EndDate,setenddate]=useState("");
  const [followers,setFollowers]= useState("");
  const [following,setFollowing]= useState('');
  const [Tokendata,SetTokendata]= useState('');
  const [token,SetToken] = useState('');
  const [address , Setaddress]=useState('');
  const [amount , Setamount] =useState('');
  const [isloaing, setisloading]=useState(false);
  const [userplanid ,Setuserplanid]=useState('');

  // GET THE OWNER DETAILS
  const getuserDetails = async () => {
  
    await axios
      .post(`${API_URL}/my-items.php?type=users&address=${account}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
       setuserdata(res.data[0]);
      })
      .catch(console.log);
  };
  
  const fetchmemberinfo=async()=>{
        let currency ;
        if(chainId==Bsc_Chainid){
            currency='BNB';
        }else if(chainId==Matic_Chainid){
            currency='MATIC';
        }else if(chainId==ETH_Chainid){
            currency='ETH';
        }
        var data = new FormData();
        data.append("type","Fetchdata");
        data.append("address",account);
        data.append("currency",currency);

        await axios.post(`${API_URL}/savecardinfo.php`, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((result)=>{
          if(result.data.length>0){
            setbuydate(result.data[0].Date)
            setenddate(result.data[0].Days);

          }
        })
  }

  const fetchismember =()=>{
    if(library){
      let contract_address;
      if(chainId==Bsc_Chainid){
        contract_address=bsccontractaddress;
      }else if(chainId==Matic_Chainid){
        contract_address=maticcontractaddress;
      }else if(chainId==ETH_Chainid){
        contract_address=ethcontractaddress;
      }

      if(contract_address){
        const Web3 = require("web3");
        const web3 = new Web3(library.provider);
        const contract =new web3.eth.Contract(ABI,contract_address);
        contract.methods.Userplan(account).call().then((planid)=>{
            Setuserplanid(planid);
          }).catch()
      } 
    }
  }
  const checkFollowing = async () => {

    if(account != undefined){

      var formdata = new FormData();
      formdata.append("followadd", account);
      formdata.append("type", "userFollowers");
      
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };
      
      fetch(`${API_URL}/user_follow.php`, requestOptions)
        .then(response => response.json())
        .then(result => {     
          setFollowers(result);
        })
        .catch(error => console.log('error', error));      
    }
  }  
  
  const checkUserFollow = async () => {
    
    var formdata = new FormData();
    formdata.append("followadd", account);
    formdata.append("type", "userFollowing");
    
    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };
    
    fetch(`${API_URL}/user_follow.php`, requestOptions)
      .then(response => response.json())
      .then(result => {                   
        if(result>0){
          setFollowing(result);
        }
      })
      .catch(error => console.log('error', error));      
   
}

    const transfertoken=async()=>{
      if(library){
       if(amount!=""  && token!="" && address!=""){
          setisloading(true);
          closeHandler();
 
          let Tokencontract;
          const Web3 = require('web3');
          const web3 = new Web3(library.provider);
          let iswebaddress = web3.utils.isAddress(address);
        
          if(iswebaddress ==true){
            let value = web3.utils.toWei(amount.toString(),"ether");
            Tokencontract = new web3.eth.Contract(tokenabi,token);
            Tokencontract.methods.transfer(address.toString(),value).send({from:account})
            .then(()=>{
              setisloading(false);
              swal({ 
                title: "Success", 
                text: "Great!....You successfully transfer your tokens",
                icon: "success" ,
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',})
            }).catch((e)=>{
              setisloading(false)
              console.log(e)})
          }else{
            swal({
              icon: "error",
              text: 'Not an ethereum address',
              title: "error",
              allowOutsideClick: false,
              confirmButtonText: 'ok',
              confirmButtonColor: '#2dbe60',
            })
          }
    
        }else{
          swal({
            icon: "error",
            text: 'Plese fill all the details',
            title: "error",
            allowOutsideClick: false,
            confirmButtonText: 'ok',
            confirmButtonColor: '#2dbe60',
          })
        }
       
      }else{
        swal({
          icon: "error",
          text: 'Please connect your wallet First',
          title: "error",
          allowOutsideClick: false,
          confirmButtonText: 'ok',
          confirmButtonColor: '#2dbe60',
        })
      }

    }

    const TokenData =async()=>{
      let changedcurrency;
      if(chainId==Bsc_Chainid){
        changedcurrency="BNB";
      }else if(chainId== Matic_Chainid){
        changedcurrency="MATIC";
      }else if(chainId== ETH_Chainid){
        changedcurrency= "ETH";
      }
      
      var data =new FormData();
      data.append("useraddress",account)
      data.append("type","SelectToken");
      data.append("currency",changedcurrency)

      await axios
      .post(`${API_URL}/TokenApi.php`, data ,{
          headers: {
              "Content-Type": "multipart/form-data",
          },
      })
      .then(async (req) => {
      
         if (req.data) {
          SetTokendata(req.data);
          }
      })
  }

  useEffect(()=>{
      TokenData();
  },[chainId,account])

  useEffect(() => {
    if(active){
      getuserDetails();
    }
  }, [active,account]);

  useEffect(()=>{
    fetchmemberinfo();
    fetchismember();
  },[account,chainId])

  useEffect(()=>{
    checkFollowing();
    checkUserFollow();
  },[account])

  return (
    <div>
  
<Box className='bgcover'>
    <img alt="" src={ user? APP_URL +'/'+user.coverphoto :Propic } width='100%' /> 
</Box> 
      <Box className='holder'>
        <Container maxWidth='xl'>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12}> 
              <Box className='bot_parts'>
                {/* <img src='./img/card-item.jpg' width='' /> */}
                <img alt ="" src={active && user? APP_URL +'/'+user.Userimage :Propic} />
                <Typography variant='h4' fontSize='25px' fontWeight='600'> {active && user ? user.Username: "Testname"}</Typography>
                <Typography variant='h6'> {active && user ?user.Useraddress: "0x00000000000000000000000"} </Typography>
              </Box>
              <br></br>
              <Box className='bio' paddingY={2}>
                <Typography variant='h6' fontSize='17px' justifyContent='center' fontWeight='normal'>
                {user.Userbio}
                </Typography>
              </Box>
              <Box display='flex' alignItems='center' justifyContent='center' fontWeight='normal'  >
                <Box className='main_work'>
                  <b>{followers}</b>  Followers
                </Box>
                <Box className='main_work'>
                  <Typography variant='' component='div' fontWeight='' >
                    <b>{following}</b> Following 
                  </Typography>
                </Box>
              </Box> 

              <Box className='con_gpl' display='flex' alignItems='center' justifyContent='center' fontWeight='Bold' paddingY={3} >
                <Box className='main_work'>
                  <Button className='follow_page' variant='contained'>
                   <Link to={'Editprofile'}> Edit Profile </Link> </Button>
                </Box>
                {userplanid>0 && new Date(Buydate).setDate(new Date(Buydate).getDate()+Number(EndDate)) > new Date().getTime() && <Box className='main_work'>
                  <Button className='follow_page' variant='contained'>
                   <Link to={'Membershipnfts'}>Create</Link> </Button>
                   <Button className='follow_page' variant='contained'>
                   <Link to={'Addtoken'}>Add Token</Link> </Button>
                   <Button className='follow_page' variant='contained' auto shadow onClick={handler}> TransferToken </Button>
                </Box>
                }
                  <Box>
                  <Modal
                    closeButton
                    aria-labelledby="modal-title"
                    open={visible}
                    onClose={closeHandler}
                  >
                    <Modal.Header>
                      <Text id="modal-title" size={18}> 
                        <Text b size={18}>
                          Transfer Token
                        </Text>
                      </Text>
                    </Modal.Header>
                    <Modal.Body>
                      <Typography gutterBottom>
                          Tokens
                      </Typography>
                      <Box sx={{position:'relative'}}>
                        <Input
                          clearable
                          bordered
                          fullWidth
                          color="primary"
                          size="lg"
                          placeholder="Tokens"
                          onChange={e=>Setamount(e.target.value)}
                          type='number' inputProps={{
                            min:0,
                            step:'any'
                          }} 
                          
                        />
                      <Box sx={{position:'absolute', top:0, right:0, bottom:0}}>
                      <Selectarea className='follow_page selectarea' onChange={(e)=>SetToken(e.target.value)}>
                        <option value="">Select</option>
                        {Tokendata.length>0 ? Tokendata.map((token,idx)=>(
                          
                          <option key={idx} value={token.Tokenaddress} >{token.TokenName}</option>
                        )):""}
                        
                        
                        </Selectarea>
                      </Box>
                      </Box>
                      <Typography gutterBottom>
                          Tokens Address
                      </Typography>
                      <Input
                        clearable
                        bordered
                        fullWidth
                        color="primary"
                        size="lg"
                        placeholder="Address"
                        onChange={e=>Setaddress(e.target.value)}
                      />
                    </Modal.Body>
                    <Modal.Footer>
                    <Button className='follow_page' variant='contained' onClick={transfertoken} style={{width:'100%',boxShadow:'none' }}>
                      Submit
                    </Button> 
                  </Modal.Footer>
                  </Modal>
                </Box>
               
                <Box className='main_work'>
                  <Typography variant='' component='div' fontWeight='Bold' >
                    <a href={`https://twitter.com/${user.Usertwitname && user.Usertwitname}`} target='blank' color='#fff'> <TwitterIcon className='ambel' /> </a>
                    <a href={`https://www.facebook.com/${user.Userfacebookname && user.Userfacebookname}`} target='blank' color='#fff'> <FacebookIcon className='ambel' />  </a>
                    <a href={`https://www.instagram.com/${user.Userinstaname && user.Userinstaname}`}  target='blank' color='#fff'>  <Instagram className='ambel' /> </a>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Profilealltab />
      {isloaing && <Loading props ={"Transaction in process, Please wait do not refresh the page..."}/>}
    </div>
  )
}

export default Myitems;
const Selectarea = styled.select`
   
`